import { NEWS_ARTICLES, newsPath } from "@/content/news";
import { AUTHORS } from "@/lib/authors";
import { PAYMENT_METHODS } from "@/lib/data";

/**
 * Publicatiestatus van de site.
 *
 * Alleen de paden hieronder gaan live. Alle overige pagina's blijven concept:
 * ze staan niet in de navigatie, niet in de interne links en niet in de
 * sitemap, en krijgen `noindex`.
 */
export const MAX_LIVE_PAGES = 70;

const METHOD_PATHS = PAYMENT_METHODS.map((m) => `/betaalmethoden/${m.slug}`);
const NEWS_PATHS = NEWS_ARTICLES.map((a) => newsPath(a));
const AUTHOR_PATHS = AUTHORS.map((a) => `/auteurs/${a.slug}`);

/** De pagina's die publiek geïndexeerd mogen worden. */
export const LIVE_PATHS: readonly string[] = [
  "/",
  "/betaalmethoden",
  ...METHOD_PATHS,
  "/lage-storting/1-euro-deposit-casinos",
  "/lage-storting/5-euro-deposit-casinos",
  "/lage-storting/10-euro-deposit-casinos",
  "/lage-storting/20-euro-deposit-casinos",
  "/casinozoeker",
  "/online-casino-snelle-uitbetaling",
  "/best-uitbetalende-online-casinos",
  "/idin-casinos",
  "/online-casino-zonder-idin",
  "/casino-zonder-cruks",
  "/online-casino-zonder-bkr",
  "/online-casino-zonder-limiet",
  "/online-casino-buitenland",
  "/nieuwe-online-casinos",
  "/betrouwbare-online-casinos",
"/review/bet365-uitbetaling",
  "/review/one-casino-uitbetaling",
  "/review/tonybet-uitbetaling",
  "/review/kokobet-uitbetaling",
  "/review/toto-uitbetaling",
  "/review/jacks-uitbetaling",
  "/review/wakuna-uitbetaling",
  "/review/axbet-uitbetaling",
  "/review/spinboss-uitbetaling",
  "/nieuws",
  ...NEWS_PATHS,
  "/auteurs",
  ...AUTHOR_PATHS,
  "/methodologie",
  "/verantwoord-spelen",
  "/contact",
  "/privacybeleid",
].slice(0, MAX_LIVE_PAGES);

const LIVE_SET = new Set(LIVE_PATHS);

/** Externe links blijven altijd toegestaan; interne alleen als ze live staan. */
export function isLivePath(href: string): boolean {
  if (/^https?:\/\//i.test(href) || href.startsWith("mailto:") || href.startsWith("tel:")) return true;
  const path = (href.split(/[?#]/)[0] ?? "").replace(/\/+$/, "") || "/";
  return LIVE_SET.has(path);
}

/** Meta-tags voor conceptpagina's: niet indexeren, geen links volgen. */
export const NOINDEX_META = [{ name: "robots", content: "noindex, nofollow" }] as const;
